import { logger } from '@source-digital/embed-core'
import { type BrowserEmbedSettings, type BrowserEmbedder } from '../browser/browser-embedder'

export function initImmediateOrOnDomReady (manager: BrowserEmbedder, settings: Partial<BrowserEmbedSettings>): void {
  const embedder = manager.register(settings)
  if (settings.immediate === true || document.readyState !== 'loading') {
    embedder.embed().catch((err: Error) => { logger.error(err) })
  } else {
    window.document.addEventListener('DOMContentLoaded', () => {
      embedder.embed().catch((err: Error) => { logger.error(err) })
    })
  }
}
